var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoinvestasi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03ACD4",
    d: "M16 0C9.53 0 3.695 3.898 1.218 9.877c-2.476 5.979-1.107 12.86 3.469 17.436 4.576 4.576 11.457 5.945 17.436 3.469C28.102 28.305 32 22.472 32 16c0-8.837-7.163-16-16-16zm-4.664 11.242c.002-1.243.527-2.428 1.446-3.265 1.043-.14 2.095-.21 3.148-.21 1.265.019 2.527.12 3.779.303.856.834 1.343 1.976 1.352 3.172v1.936h-9.609l-.116-1.936zm5.854 5.434c0 .54-.327 1.026-.826 1.23-.5.205-1.074.087-1.452-.298-.378-.385-.486-.961-.273-1.457.213-.496.705-.814 1.245-.804.35 0 .686.14.932.39.245.25.38.589.374.94zM6.6 12.011c.222-1.905 1.676-3.436 3.568-3.755h.723c-.552.906-.843 1.948-.84 3.01V13.2H6.625l-.023-1.19zm17.12 10.473c-.265.773-.941 1.332-1.75 1.446-4.062.56-8.182.56-12.245 0-.8-.123-1.465-.68-1.726-1.446-.933-2.52-1.445-5.175-1.516-7.86h6.787v2.005c-.13.96.288 1.913 1.082 2.468.794.555 1.831.621 2.689.17.857-.45 1.391-1.342 1.384-2.311.023-.108.023-.219 0-.327v-1.935h6.81c-.045 2.677-.517 5.33-1.4 7.86l-.116-.07zm-1.377-9.33v-1.936c.009-1.015-.257-2.014-.77-2.892 1.872.333 3.31 1.846 3.546 3.732v1.073l-2.776.023z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoinvestasi);
export default __webpack_public_path__ + "static/media/goinvestasi.ea477a20bdaff0a0bfe43fcd5a3173ed.svg";
export { ForwardRef as ReactComponent };